'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// ./node_modules/.15.6.2@react/react.js
// module id = 1067
// module chunks = 1